import PATHS from '../constants';

function fetchTestimonial() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.HOME_TESTIMONIAL, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchTestimonial;